export default __webpack_public_path__ + "static/media/question-bg.f62d079a.png";